/**
 * Parses the two Retry-After forms defined for HTTP responses without keeping
 * any request credential or response body. Invalid values deliberately fall
 * back to an ordinary retryable error instead of inventing a cooldown.
 */
export function retryAfterSecondsFromHeader(
  value: string | null,
  nowMilliseconds = Date.now(),
): number | null {
  if (value === null) return null;
  const normalized = value.trim();
  if (!normalized) return null;

  if (/^\d+$/u.test(normalized)) {
    const seconds = Number(normalized);
    return Number.isSafeInteger(seconds) ? seconds : null;
  }

  // A value beginning with a number is neither a valid delta-seconds value nor
  // an HTTP date. Reject it before Date.parse can reinterpret it as a local date.
  if (/^[+-]?\d/u.test(normalized)) return null;
  const availableAt = Date.parse(normalized);
  if (!Number.isFinite(availableAt) || !Number.isFinite(nowMilliseconds)) return null;
  return Math.max(0, Math.ceil((availableAt - nowMilliseconds) / 1_000));
}
